import React from "react";
import PlanCards from "../../containers/Pricing/Pricing.PlanCards";
import ModeSwitcher from "../ModeSwitcher/ModeSwitcher";
import LangSwitcher from "../LangSwitcher/LangSwitcher";
import Title from "../Section/Section.Title";
import Section from "../Section/Section";

import { triggerContact } from "../../redux/appReducer";
import { useDispatch, useSelector } from "react-redux";
import { FOOTER } from "../../intl/footer";
import { Link } from "gatsby";

const Footer = () => {
  const { lang, LOGO, DASHBOARD_URL, SOCIAL_MEDIA_HANDLERS } = useSelector(
    (state) => state.appReducer
  );
  const copy = FOOTER[lang];

  const dispatch = useDispatch();

  const social = [
    {
      id: "facebook",
      name: "Facebook",
    },
    {
      id: "instagram",
      name: "Instagram",
    },
    {
      id: "linkedin",
      name: "LinkedIn",
    },
  ];

  const products = {
    product: [
      {
        name: copy.product.valuations,
        href: "/valuations",
      },
      {
        name: copy.product.metasearch,
        href: "/metasearch",
      },
      {
        name: copy.product.insights,
        href: "/insights",
      },
      {
        name: copy.product.website,
        href: "/website",
      },
      {
        name: copy.product.digitalValuer,
        href: "/digital-valuer",
      },
    ],
    solutions: [
      {
        name: copy.solutions.portfolio,
        href: "/portfolio",
      },
      {
        name: copy.solutions.risk,
        href: "/risk",
      },
      {
        name: copy.solutions.opportunities,
        href: "/opportunity",
      },
      {
        name: copy.solutions.avms,
        href: "/avms",
      },
      {
        name: copy.solutions.observatory,
        href: "/observatory",
      },
    ],
    company: [
      {
        name: copy.company.about,
        href: "/about",
      },
      {
        name: copy.company.careers,
        href: "/careers",
      },
      {
        name: copy.company.cases,
        href: "/use-cases",
      },
    ],
    help: [
      {
        name: copy.help.contact,
        type: "button",
        function: (value) => dispatch(triggerContact()),
      },
    ],
  };

  const product_categories = [
    {
      id: "product",
      name: copy.product.title,
    },
    {
      id: "solutions",
      name: copy.solutions.title,
    },
    {
      id: "company",
      name: copy.company.title,
    },
    {
      id: "help",
      name: copy.help.title,
    },
  ];

  return (
    <div>
      <footer className="bg-neutral-900 text-white pt-10 pb-5 sm:pb-40 text-center">
        <Title t1={copy.planTitle.t1} contrast></Title>
        <Section>
          <PlanCards />
        </Section>

        <Title
          t1={copy.footerTitle.t1}
          t2={copy.footerTitle.t2}
          action={copy.footerTitle.action}
          href={DASHBOARD_URL}
          contrast
        ></Title>
        <Section>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-5 text-start pb-20 items-start">
            {product_categories.map((category, idx) => {
              return (
                <div className="grid gap-y-5 sm:gap-y-2" key={idx}>
                  <div>
                    <b className="text-[14px]">{category.name}</b>
                  </div>
                  {products[category.id].map((i, idx) => {
                    if (i.type === "button" && i.function)
                      return (
                        <div
                          className="text-[12px] text-neutral-300 cursor-pointer"
                          onClick={i.function}
                          key={idx}
                        >
                          {i.name}
                        </div>
                      );

                    return (
                      <Link to={i.href} key={idx}>
                        <div className="text-[12px] text-neutral-300">
                          {i.name}
                        </div>
                      </Link>
                    );
                  })}
                </div>
              );
            })}
          </div>
        </Section>
        <Section>
          <div className="w-full flex  border-b-[1px] border-neutral-700 pb-5  items-center">
            <div className="flex justify-start flex-1">
              <Link to="/">
                <img
                  className="max-h-[30px] sm:max-h-[35px] md:max-h-[35px] block"
                  loading="lazy"
                  height="100%"
                  src={LOGO.dark}
                  alt="logo"
                />
              </Link>
            </div>
            <div>
              <ModeSwitcher />
            </div>
            <div className="pl-5">
              <LangSwitcher />
            </div>
          </div>
        </Section>
        <Section>
          <div className="w-full grid grid-cols-1 sm:grid-cols-3 pt-5 gap-2.5 items-center">
            <div className="col-span-1 text-left text-[12px] text-neutral-300">
              {copy.countries}
            </div>
            <div className="col-span-1 flex gap-5 justify-start sm:ustify-center">
              {social.map((socialInfo, idx) => (
                <a
                  href={SOCIAL_MEDIA_HANDLERS[socialInfo.id]}
                  target="_blank"
                  key={socialInfo.id}
                >
                  <div className={"text-md text-neutral-300"}>
                    {socialInfo.name}
                  </div>
                </a>
              ))}
            </div>
            <div className="col-span-1">
              <div className="flex gap-5 justify-start sm:justify-end">
                <Link to="/terms">
                  <div className="text-[12px] text-neutral-300">
                    {copy.terms}
                  </div>
                </Link>
                <Link to="/privacy">
                  <div className="text-[12px] text-neutral-300">
                    {copy.privacy}
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </Section>
      </footer>
    </div>
  );
};

export default Footer;
